/* This file contains sagas related to free-text survey */

import { put, call, select } from 'redux-saga/effects';
import * as QuestionnaireAPI from '../apis/surveys';
import { buildFreeTextQuestionnaire, loadFreeTextSurveyQuestionnaire, setFreeTextSurveyQuestionnaireLoadingResult, retrieveCurrentVisit } from '../actions';
import { LoadingStatus, LoadingResult } from '../utils/LoadingUtils';
import { getFreeTextQuestion, getPatientId } from '../selectors';
import moment from 'moment';

export function* freeTextSurveyQuestionnaireSaga() {
    yield put(loadFreeTextSurveyQuestionnaire(LoadingStatus.STARTED));
    try {
        const questionnaire = yield call(QuestionnaireAPI.getFreeTextSurveyQuestionnaire);
        const question = processFreeTextSurveyQuestionnaire(questionnaire.data);
        yield put(buildFreeTextQuestionnaire(question));
        yield put(setFreeTextSurveyQuestionnaireLoadingResult(LoadingResult.SUCCESSFUL));
    } catch (error) {
        if (!!error.response && error.response.status === 401) {
            // fill in with right error message
            console.log('authentication error');
        } else {
            // fill in with right error message
            console.log('all other error messages');
        }
        yield put(setFreeTextSurveyQuestionnaireLoadingResult(LoadingResult.FAILED));
    }
    yield put(loadFreeTextSurveyQuestionnaire(LoadingStatus.ENDED));
}

export function* freeTextSurveyQuestionnaireResponseSaga(action) {
    try {
        let question = yield select(getFreeTextQuestion);
        const patientId = yield select(getPatientId);
        const questionnaireResponse = generateFreeTextQuestionnaireResponse(question, patientId, action.answer);
        yield call(QuestionnaireAPI.postQuestionnaireResponse, questionnaireResponse);
        if (action.refreshVisit) {
            yield put(retrieveCurrentVisit());
        }
        /* dispatch result of data submission */
        if (action.dispatchDataSubmissionResult) {
            yield put(action.dispatchDataSubmissionResult(true));
        }
    } catch (error) {
        /* dispatch result of data submission */
        if (action.dispatchDataSubmissionResult) {
            yield put(action.dispatchDataSubmissionResult(false));
        }
        console.dir(error);
    }
}

const generateFreeTextQuestionnaireResponse = (question, patientId, answer) => {
    const currentTime = moment().format();

    return {
        resourceType: 'QuestionnaireResponse',
        questionnaire: {
            reference: 'Questionnaire/freeTextSurvey',
        },
        status: 'completed',
        subject: {
            reference: `Patient/${patientId}`,
        },
        authored: `${currentTime}`,
        author: {
            reference: `Patient/${patientId}`,
        },
        item: [
            {
                linkId: question.title,
                item: [
                    {
                        linkId: question.linkId,
                        text: question.text,
                        answer: [
                            {
                                valueString: answer,
                            },
                        ],
                    },
                ],
            },
        ],
    };
};

const processFreeTextSurveyQuestionnaire = questionnaire => {
    const questionGroup = questionnaire.item[0];
    return {
        linkId: questionGroup.item[0].linkId,
        title: questionGroup.text,
        text: questionGroup.item[0].text,
        answer: '',
    };
};
